// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__vMEB8","left":"layout_left__CFlZZ","right":"layout_right__dgjEP","top":"layout_top__IZoxt","center":"layout_center__xR+BT","loading":"layout_loading__8O58z"};